import { FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import HeaderComponent from '../../../../components/header/Header.component';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import Loading from '../../../../components/portalComponents/Loading.component';
import GenericButtons from '../../../../components/UI components/Buttons/GenericButtons';
import { POST, requestInfo, estateEndpoints, endpoints } from '../../../../services/modulesServices/userManagement.api';
import { cross, check, warning } from '../../../../utils/Logo';
import { DROPDOWN_DATA, PAYMENT_DETAILS } from './EstateEmpPayment.const';
import { dprDropdownDataOptions } from '../../Workspace/DPR creation screen/DPR.controller';
import { documentDownloadV2 } from '../../../../utils/utils';
import { CONSTANT_DATA_FIELD } from '../../../../utils/constants';

export default function EstateEmpPayment() {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [dropdownData, setDropdownData] = useState<any>({ DROPDOWN_DATA });
    const [estateData, setEstateData] = useState<any>([]);

    const getUserDetails = JSON.parse(localStorage.getItem('user') || '{}');
    const userUuid = getUserDetails?.uuid;

    let user = localStorage.getItem('currentUserAssignment');
    let designation = user ? String(JSON.parse(user)?.designation?.code) : '';

    const formik = useFormik<any>({
        initialValues: { isUpdatable: true, fromDate: '', toDate: '', downloadOption: '', paymentTypes: null },
        onSubmit: () => {}
    });
    const { values, setValues } = formik;
    console.log(formik);

    const fetchDropdownData = async () => {
        try {
            setIsLoading(true);
            const commonDropdownData = await dprDropdownDataOptions();
            let estateDropdown;

            if (designation === 'FM_SITE') {
                const { data } = await POST(`${endpoints.estateDropDown}?userUuids=${userUuid}&isEstateDetailsRequired=true`, { RequestInfo: requestInfo() });
                const estateValues = data?.estateManagers?.map((val: any) => ({
                    estateName: val?.estateDetails?.estateName,
                    estateId: val?.estateDetails?.uuid
                }));
                setEstateData(estateValues);
                estateDropdown = estateValues.map((value: any) => ({
                    name: value?.estateName,
                    code: value?.estateId
                }));
            } else {
                const { data } = await POST(estateEndpoints.estateSearch, { RequestInfo: requestInfo() });
                estateDropdown = data?.estateMasterDetails?.map((val: any) => ({
                    name: val?.estateName,
                    code: val?.uuid
                }));
            }
            setDropdownData({
                ...dropdownData.DROPDOWN_DATA,
                ...commonDropdownData,
                estate: estateDropdown
            });
            setIsLoading(false);
        } catch (error: any) {
            setIsLoading(false);
            const errMsg = error.response?.data?.errorMessage || error?.message;
            setModalDetails({
                show: true,
                title: 'Action Unsuccessful',
                para: errMsg,
                img: cross,
                type: 'error',
                reUpload: 'OK'
            });
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, [designation, userUuid]);

    useEffect(() => {
        const getEstateId = estateData?.find((val: any) => values?.estate?.code === val?.estateName);
        setValues((prev: any) => ({ ...prev, estateId: getEstateId?.estateId }));
    }, [estateData, values?.estate?.code]);

    console.log('dropdowndata', dropdownData);

    const handleModalClose = (type: string) => {
        setModalDetails({});
    };

    const downloadPaymentReceipt = async () => {
        const newFromDate = new Date(values.fromDate);
        const newToDate = new Date(values.toDatePayment);

        newFromDate.setHours(0, 0, 0, 0);

        newToDate.setHours(23, 59, 59, 999);

        const fromDate = newFromDate.getTime();
        const toDate = newToDate.getTime();
        const paymentOptions = values.paymentTypes?.code ? [values.paymentTypes.code] : ['WATER_CHARGES', 'HOUSE_TAX'];
        const paymentTypes = designation === 'FM_SITE' ? paymentOptions : null;
        try {
            setIsLoading(true);
            const { data } = await POST(endpoints.empPayment, {
                RequestInfo: requestInfo(),
                estateId: values?.estate?.code,
                paymentFromDate: fromDate,
                paymentToDate: toDate,
                paymentTypes,
                downloadOption: values.downloadOption?.code
            });
            if (data.fileStoreIds?.length > 0) {
                documentDownloadV2(data.fileStoreIds);
                setModalDetails({
                    show: true,
                    title: t('SUCCESS', 'Success'),
                    para: t('RECEIPT_DOWNLOADED_SUCCESSFULLY', 'Receipt downloaded successfully.'),
                    img: check,
                    type: 'success',
                    reUpload: t('OK', 'OK')
                });
            } else {
                setModalDetails({
                    show: true,
                    title: 'Warning!',
                    para: 'No payment receipts found for the selected period.',
                    img: warning,
                    type: 'warning',
                    reUpload: 'OK'
                });
            }
            setIsLoading(false);
        } catch (e: any) {
            setIsLoading(false);
            let errMsg = e.response?.data?.errorMessage || e.message;
            setModalDetails({
                show: true,
                title: t('ERROR', 'Error!'),
                para: errMsg || t('SOMETHING_WENT_WRONG', 'Something went wrong!'),
                img: cross,
                type: 'error',
                reUpload: 'OK'
            });
        }
    };

    const paymentDetails =
        designation !== 'FM_SITE'
            ? PAYMENT_DETAILS
            : PAYMENT_DETAILS.map((val: any) => {
                  return {
                      ...val,
                      formData: [
                          ...val.formData.map((value: any) => {
                              if (value?.field === 'estate') {
                                  return { ...value, isRequired: true };
                              } else {
                                  return { ...value };
                              }
                          }),
                          {
                              titleCode: 'PAYMENT_TYPE',
                              title: 'Payment Type',
                              field: 'paymentTypes',
                              type: CONSTANT_DATA_FIELD.SELECT_FIELD,
                              class: 'col-sm-4'
                          }
                      ]
                  };
              });

    return (
        <>
            {isLoading && <Loading />}
            <HeaderComponent />
            <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                <GenericHeader text={t('PAYMENT_DOCUMENTS', 'Download Payment Documents')} />
                <div className='col-12 form-section'>
                    <FormikProvider value={formik}>
                        <Card className='card_border'>
                            <Card.Body>
                                <div className='row my-0'>
                                    {paymentDetails.map(val => (
                                        <GenericFormCard key={val.formData[0].field} {...val} dropdownOptions={dropdownData} />
                                    ))}
                                </div>
                            </Card.Body>
                        </Card>
                    </FormikProvider>
                </div>
            </div>
            <footer className='footer fixed-bottom footerBtnPatch'>
                <div className='d-flex justify-content-end container me-3' style={{ padding: 15 }}>
                    <GenericButtons
                        text='Download'
                        variant='primary'
                        handleClick={downloadPaymentReceipt}
                        disabled={(designation === 'FM_SITE' && !values?.estate?.code) || !values.fromDate || !values.toDatePayment || !values.downloadOption}
                    />
                </div>
            </footer>
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type)}
            />
        </>
    );
}
